import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../types/store';

import { changePage } from '../../store/filters/actions';
import { Pagination } from './index';

export const mapStateToProps = (state: IApplicationState) => ({
  filters: state.filters,
  totalPages: state.villageList.totalPages,
});

export const mapDispatchToProps = (dispatch: TTypedThunkDispatch) => ({
  onSelect: (p: number) => {
    dispatch(changePage(p));
  },
});

export const PaginationContainer = connect(mapStateToProps, mapDispatchToProps)(Pagination);
